module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/community-rules.json
// module id = 680
// module chunks = 233847514843302